<script>
 // import StringUtils from '@common/StringUtils'
 // import {EventStatus, ProcedureType, Accommodation} from "@common/status";

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const DEFAULT_VALUE = null;

export default {
  name: 'FcmImageEditor',
  components: {VueCropper},
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      validator: (value)=>{return true},
      default: ()=>{return null;},
    },
    dataUrlOriginal: {
      validator: (value)=>{return true},
      default: ()=>{return null;},
    },
    fixOnStart: {
      type: Boolean,
    },
    showModal: {
      type: Boolean,
    },
    aspectRatio: {
      type: Number,
      default: 1
    },
    maxWidth: {
      type: Number,
      default: 1024
    },
    maxHeight: {
      type: Number,
      default: 1024
    },
    cropperWidth: {
      type: Number,
      default: 450
    },
    cropperHeight: {
      type: Number,
      default: 450
    },
    fillColor: {
      type: [String, null],
      default: null
    },
    mimeType: {
      type: [String],
      default: 'image/png'
    },
    qualityArgument: {
      type: [Number],
      default: 1
    },
    formatCropper: {
      type: [String],
      default: 'squad' // squad | circle
    },
    showExtraActions: {
      type: Boolean,
    }
  },
  data(vm) {
    return {
      internalLazyValue: vm.updateInternalLazyValue(vm.value, vm.fixOnStart),
      internalErrorMessages: [],
      hasInput: false,

      imgEditor: {
        scaleX: 1,
        scaleY: 1
      },
      teste: false,
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.internalLazyValue;
      },
      set(val) {
        this.updateInternalLazyValue(val, true);
      }
    },
    internalShowModal: {
      get() {
        return this.showModal;
      },
      set(val) {
        this.cancel();
      }
    }
  },
  watch: {
    value(value) {
      this.updateInternalLazyValue(value, this.fixOnStart);
    },
    dataUrlOriginal(value) {
      this.$refs.cropper?.replace(value);
    }
  },
  mounted: async function() {

  },
  beforeDestroy: function() {
  },
  methods: {
    reset () {
      this.hasInput = false;
      this.internalErrorMessages = [];
      this.updateInternalLazyValue(DEFAULT_VALUE, true);
      this.removeFocus();
    },
    resetValidation () {
      this.hasInput = false;
      this.internalErrorMessages = [];
    },
    validate (force=false) {
      this.internalErrorMessages = [];
      for (const rule of this.rules) {
        const result = typeof rule === 'function' ? rule(this.internalLazyValue) : rule;
        if (typeof result === 'string') {
          this.internalErrorMessages.push(result);
        }
      }
      if (force) {
        this.hasInput = true;
      }
      return this.internalErrorMessages.length === 0;
    },



    /**
     * Formato dos dados de saída
     */
    toModel(value) {
      return value;
    },
    removeFocus() {

    },
    /**
     * Alterar esse método para manter a consistência do seu dado interno (internalLazyValue)
     * @param value
     * @param emit
     */
    updateInternalLazyValue(value, emit=false) {
      if(!value) {
        value = DEFAULT_VALUE;
      }
      if(value===DEFAULT_VALUE && this.internalLazyValue===DEFAULT_VALUE) {
        return;
      }
      if (value===DEFAULT_VALUE || this.internalLazyValue===DEFAULT_VALUE || !_.isEqual(this.internalLazyValue, value)) {
        this.resetValidation();
        this.internalLazyValue = value;
      //  this.showModal = Boolean(value);
       // this.$refs.cropper?.replace(value);
       // this.updatePreview(value)
        if(emit) {
          this.$emit('input', this.toModel(this.internalLazyValue));
        }
      }
    },
    cropEnd(e) {
      // this.updatePreview()
    },
    done() {
      this.updatePreview();
      this.$emit('done', this.internalLazyValue);
    },
    cancel() {
      this.updatePreview();
      this.$emit('cancel');
    },
    insertImage() {
      console.error('insertImage not exist more, use FcmImage::editFile')
    },
    scaleX() {
      this.imgEditor.scaleX *= -1;
      this.$refs.cropper.scaleX(this.imgEditor.scaleX)
      this.updatePreview()
    },
    scaleY() {
      this.imgEditor.scaleY *= -1;
      this.$refs.cropper.scaleY(this.imgEditor.scaleY)
      this.updatePreview()
    },
    rotate(value) {
      this.$refs.cropper.rotate(value)
      this.updatePreview()
    },
    relativeZoom(value) {
      this.$refs.cropper.relativeZoom(value)
      this.updatePreview()
    },

    updatePreview() {
      if(!this.$refs.cropper) {
        console.warn('Não tem this.$refs.cropper');
        return;
      }

      if (this.mimeType === 'image/png' && this.dataUrlOriginal) {
        this._updatePreviewPng();
        return;
      }

      let canvasOld = this.$refs.cropper.getCroppedCanvas({
        maxWidth: this.maxWidth,
        maxHeight: this.maxHeight,
        fillColor: this.fillColor || '#ffffff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      });
      let canvas = canvasOld;
      if(this.formatCropper==='circle') {
        canvas = document.createElement('canvas');
        canvas.width = canvasOld.width;
        canvas.height = canvasOld.height;
        let ctx = canvas.getContext('2d');

        let cw=canvas.width;
        let ch=canvas.height;
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, cw, ch);

        ctx.arc(cw/2,ch/2,ch/2,0,Math.PI*2);
        ctx.clip();
        ctx.drawImage(canvasOld, 0, 0);
      }
      if(!canvas) {
        console.warn('Não tem canvas (this.$refs.cropper.getCroppedCanvas)');
        return;
      }
      this.updateInternalLazyValue(canvas.toDataURL(this.mimeType, this.qualityArgument), true);
    },
    _updatePreviewPng() {
      const cropData = this.$refs.cropper.getData(true);
      const imgData = this.$refs.cropper.getImageData();

      let outW = cropData.width;
      let outH = cropData.height;
      if (this.maxWidth && outW > this.maxWidth) {
        outH = Math.floor(outH * this.maxWidth / outW);
        outW = this.maxWidth;
      }
      if (this.maxHeight && outH > this.maxHeight) {
        outW = Math.floor(outW * this.maxHeight / outH);
        outH = this.maxHeight;
      }

      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, outW);
      canvas.height = Math.max(1, outH);
      const ctx = canvas.getContext('2d');

      const img = new Image();
      img.onload = () => {
        const rotate = imgData.rotate || 0;
        const scaleX = imgData.scaleX != null ? imgData.scaleX : 1;
        const scaleY = imgData.scaleY != null ? imgData.scaleY : 1;

        ctx.save();
        if (rotate !== 0 || scaleX !== 1 || scaleY !== 1) {
          ctx.translate(outW / 2, outH / 2);
          ctx.rotate(rotate * Math.PI / 180);
          ctx.scale(scaleX, scaleY);
          ctx.translate(-outW / 2, -outH / 2);
        }
        ctx.drawImage(img, cropData.x, cropData.y, cropData.width, cropData.height, 0, 0, outW, outH);
        ctx.restore();
        this.updateInternalLazyValue(canvas.toDataURL(this.mimeType, this.qualityArgument), true);
      };
      img.src = this.dataUrlOriginal;
    },
    remove() {
      this.$emit('remove');
    },
    show() {
      this.$emit('show');
    },
    testando() {
      console.log('getData', this.$refs.cropper.getData());
    },
    selectNewFile() {
      this.$emit('selectNewFile');
    },
  },
}
</script>


<template>
  <VDialog v-if="dataUrlOriginal" v-model="internalShowModal" :class="$style.modal" :fullscreen="$vuetify.breakpoint.xs"
  >
    <div :class="$style.box">
      <div :class="$style.content">
        <div :class="$style.cropper">
          <VueCropper
              v-show="dataUrlOriginal"
              ref="cropper"
              :guides="true"
              :view-mode="0"
              drag-mode="crop"
              :auto-crop-area="1"
              :aspect-ratio="aspectRatio"
              :initial-aspect-ratio="aspectRatio"
              :background="true"
              :rotatable="true"
              :zoomable="true"
              :scalable="true"
              :src="dataUrlOriginal"
              alt="Source Image"
              :cropend="cropEnd"
              :viewport="{type: 'circle'}"
          >
          </VueCropper>
          <div :class="$style.actionsIcons">
            <div @click="done()"><VIcon :class="$style.actionsIconDone">mdi-check</VIcon></div>
<!--            <div @click="cancel()"><VIcon :class="$style.actionsIconCancel" >mdi-cancel</VIcon></div>-->
          </div>
        </div>
        <div v-if="internalValue" :class="$style.edit">
          <VBtn fab small class="ma-1" @click="rotate(-45)">
            <VIcon>mdi-rotate-left</VIcon>
            <VTooltip md-direction="top">{{$t('image.rotateLeft')}}</VTooltip>
          </VBtn>
          <VBtn fab small class="ma-1" @click="rotate(45)">
            <VIcon>mdi-rotate-right</VIcon>
            <VTooltip md-direction="top">{{$t('image.rotateRight')}}</VTooltip>
          </VBtn>

          <VBtn fab small class="ma-1" @click="relativeZoom(0.1)">
            <VIcon>mdi-magnify-plus-outline</VIcon>
            <VTooltip md-direction="top">{{$t('image.zoomIn')}}</VTooltip>
          </VBtn>
          <VBtn fab small class="ma-1" @click="relativeZoom(-0.1)">
            <VIcon>mdi-magnify-minus-outline</VIcon>
            <VTooltip md-direction="top">{{$t('image.zoomOut')}}</VTooltip>
          </VBtn>

          <VBtn fab small class="ma-1" @click="scaleX()">
            <VIcon>mdi-swap-horizontal</VIcon>
            <VTooltip md-direction="top">{{$t('image.mirrorX')}}</VTooltip>
          </VBtn>
          <VBtn fab small class="ma-1" @click="scaleY()">
            <VIcon>mdi-swap-vertical</VIcon>
            <VTooltip md-direction="top">{{$t('image.mirrorY')}}</VTooltip>
          </VBtn>
          <VBtn fab small class="ma-1" @click="selectNewFile()">
            <VIcon>mdi-selection-search</VIcon>
            <VTooltip md-direction="top">{{$t('image.selectNewFile')}}</VTooltip>
          </VBtn>
          <VBtn v-if="showExtraActions" fab small class="ma-1" @click="show()">
            <VIcon>mdi-eye</VIcon>
            <VTooltip md-direction="top">{{$t('image.show')}}</VTooltip>
          </VBtn>
          <VBtn v-if="showExtraActions" fab small class="ma-1" @click="remove()">
            <VIcon>mdi-delete</VIcon>
            <VTooltip md-direction="top">{{$t('image.remove')}}</VTooltip>
          </VBtn>
        </div>
        <div :class="$style.actions">
<!--          <VBtn :class="['ma-1', $style.button]" @click="cancel()">-->
<!--            {{$t('form.cancel')}}-->
<!--          </VBtn>-->
          <VBtn :class="['ma-1', $style.button]" @click="done()">
            {{$t('form.conclude')}}
          </VBtn>
        </div>
      </div>
    </div>
  </VDialog>
</template>


<style lang="scss" module>
// @import '@design';

.inputImage {
  display: none;
}

.modal {
  // padding-left: 20px;
  // padding-right: 20px;

  > div {
    @media screen and (max-height: 700px) {
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      border-radius: 0;
      transform: none;
    }
  }
}
.box {
  background-color: var(--v-modalBg-base);
  .content {
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .cropper {
      position: relative;
      min-width: 200px;
      max-width: 1000px;
      .actionsIcons {
        display: block;
        position: absolute;
        top:10px;
        right: 10px;
        div {
          display: inline;
          .actionsIconDone {
            color: green;
            font-size: 32px!important;
            cursor: pointer;
          }
          .actionsIconCancel {
            margin-left: 10px;
            font-size: 27px!important;
            cursor: pointer;
          }
        }
      }
    }

    .edit {
      margin-top: 10px;
    }
  }
}


.separator {
  margin-left: 18px;
}




.button {
  margin: 0;
  padding-left: 10px;
  padding-right: 10px;
}


</style>





















